import './immobile-title.scss';

const COMPONENT_NAME = 'immobile-title';

const CSS_CLASS = {
  IS_STICKY: 'is-sticky',
};

const CSS_VAR = {
  STICKY_TOP: '--immobile-title-top',
};

const BODY_CLASS = {
  IS_STICKY: 'immobile-title-is-sticky',
};

/**
 * version    1.4
 * class      ImmobileTitle
 * classdesc  Component that manages the sticky immobile title section.
 */
export class ImmobileTitle {
  constructor() {
    this._findUIElements();
    if (!this._els.title) return;
    this._init();
  }

  _findUIElements() {
    this._els = {
      title: document.querySelector(`.js-${COMPONENT_NAME}`),
      primaryHeader: document.querySelector('.primary-header'),
    };
  }

  _init() {
    this._stickyTop = 0;
    this._sentinel = null;
    this._observer = null;

    this._setStickyTop();

    if (this._isDesktop()) {
      this._createSentinel();
      this._initObserver();
    }

    this._bindEvents();
  }

  _isDesktop() {
    return window.matchMedia('(min-width: 992px)').matches;
  }

  // Legge --header-sticky-bottom da .primary-header — CSS variable impostata in header.scss (86px desktop, 50px mobile)
  _setStickyTop() {
    const { primaryHeader } = this._els;

    if (primaryHeader) {
      const cssVal = window.getComputedStyle(primaryHeader).getPropertyValue('--header-sticky-bottom').trim();
      this._stickyTop = parseFloat(cssVal) || 0;
    } else {
      this._stickyTop = 0;
    }

    this._els.title.style.setProperty(CSS_VAR.STICKY_TOP, `${this._stickyTop}px`);
  }

  // Inserisce un elemento sentinella a zero altezza nel flusso normale, immediatamente prima della section. L'IntersectionObserver lo usa come trigger.
  _createSentinel() {
    this._sentinel = document.createElement('div');
    this._sentinel.setAttribute('aria-hidden', 'true');
    // Rimane nel flusso (no position: absolute) per essere tracciato correttamente
    this._sentinel.style.cssText = 'height:0;margin:0;padding:0;border:0;overflow:hidden;';
    this._els.title.parentNode.insertBefore(this._sentinel, this._els.title);
  }

  // Quando la sentinella esce dall'area visibile (scorrendola oltre il fondo dell'header), aggiunge le classi is-sticky.
  _initObserver() {
    this._observer = new IntersectionObserver(
      ([entry]) => {
        const isSticky = !entry.isIntersecting;
        this._els.title.classList.toggle(CSS_CLASS.IS_STICKY, isSticky);
        document.body.classList.toggle(BODY_CLASS.IS_STICKY, isSticky);
      },
      {
        rootMargin: `-${this._stickyTop}px 0px 0px 0px`,
        threshold: 0,
      },
    );

    this._observer.observe(this._sentinel);
  }

  _bindEvents() {
    window.addEventListener('resize', () => {
      // Ricalcola: il breakpoint può cambiare il valore di --header-sticky-bottom
      this._setStickyTop();

      if (this._isDesktop()) {
        if (!this._sentinel) {
          this._createSentinel();
        }
        if (this._observer) {
          this._observer.disconnect();
        }
        this._initObserver();
      } else {
        // Mobile: rimuovi sentinel e observer se presenti
        if (this._observer) {
          this._observer.disconnect();
          this._observer = null;
        }
        if (this._sentinel && this._sentinel.parentNode) {
          this._sentinel.parentNode.removeChild(this._sentinel);
          this._sentinel = null;
        }
        this._els.title.classList.remove(CSS_CLASS.IS_STICKY);
        document.body.classList.remove(BODY_CLASS.IS_STICKY);
      }
    });
  }

  destroy() {
    if (this._observer) this._observer.disconnect();
    if (this._sentinel && this._sentinel.parentNode) {
      this._sentinel.parentNode.removeChild(this._sentinel);
    }
    document.body.classList.remove(BODY_CLASS.IS_STICKY);
  }
}
